import script from "./OverviewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OverviewPage.vue?vue&type=script&setup=true&lang=js"

import "./OverviewPage.vue?vue&type=style&index=0&id=5356c009&lang=scss"

const __exports__ = script;

export default __exports__